module.exports = __webpack_public_path__ + "img/deco_heart_r.a53ad5f1.webp";